import { useAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { omniAtom } from "src/utils/atoms";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { PogAtom } from "src/components/Planogram/store/types";

export interface EditShelfData {
  shelves: PlanogramShelf[];
  pogAtom: PogAtom;
  setIsModified?: (modified: boolean) => void;
}

const editShelfAtom = omniAtom<null | EditShelfData>({
  key: "ModalEditShelf",
  value: null,
});

export const useEditShelfModal = () => {
  const { openModal, closeModal } = useModals();
  const [editShelfData, setEditShelfData] = useAtom(editShelfAtom);

  const openEditShelfModal = (
    shelves: PlanogramShelf[],
    pogAtom: PogAtom,
    setIsModified?: (modified: boolean) => void,
  ) => {
    if (shelves.length !== 1) return;
    setEditShelfData({ shelves, pogAtom, setIsModified });
    openModal("ModalEditShelf");
  };

  const closeEditShelfModal = () => {
    setEditShelfData(null);
    closeModal("ModalEditShelf");
  };

  return { openEditShelfModal, closeEditShelfModal, editShelfData };
};
